module.exports = __webpack_public_path__ + "static/img/7-fr.f9b15ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/title-level/img/7-fr.png
// module id = NIJq
// module chunks = 1